import * as React from 'react'
import MUIFormControl from '@mui/material/FormControl'

const FormControl = (props) => <MUIFormControl {...props} />

export default FormControl
